const compareTable = {
    props: {
        records: null
    },
    data(){
        return{
            tooltips: []
        }
    },
    template:
    `<div class="b-table-compare">
        <template v-for="(list, label, index) in records">        
            <div class="b-table-compare__th">
                <template v-for="(item, innerIndex) in list">
                    <span v-if="innerIndex===0" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-html="true" :data-bs-original-title="item.tltp" :class="tooltipClass(item)"></span>
                    <span v-if="innerIndex===0" v-html="item.lbl"></span>
                </template>
            </div>
            <div class="b-table-compare__body">
                <div v-for="(item, innerIndex) in list" class="b-table-compare__body__item" v-html="item.val"></div>
            </div>
        </template>
    </div>`,
    created(){
        this.$watch(
            () => this.records,
            (newVal, oldVal) => {
              this.showTooltips()
            }
          )
    },
    mounted () {
        this.showTooltips()
        
	},
    methods:{
        showTooltips(){
            
            if(this.records){
                this.$nextTick(()=>{

                    jQuery('[data-bs-toggle="tooltip"]', jQuery(this.$el)).each((index, item) =>{        
                        new bootstrap.Tooltip(jQuery(item)[0], {
                            container: jQuery(item).parent()
                        })
                    })
                })
                
            }
        },
        tooltipClass(item){
            if(item && item.tltp){
                return 'e-tooltip'
            }
            return ''
        }
    },
    computed:{
    }
}